// extracted by mini-css-extract-plugin
export default {"container":"gNcmorlDNm5pP__v2MXa"};